import authActions from 'src/modules/auth/authActions';

export default function authInitializer(store) {
  if (!store || !store.dispatch) {
    return;
  }

  store.dispatch(authActions.doInit());
}
